import React, { useRef, useEffect, useState } from "react";
import cx from "classnames";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import LogoBlack from '../../../../static/icons/logo-black.svg';
import ChevronRightIcon from '../../../../static/icons/chevron_right.svg';

import styles from '../../../../components/header/Header.module.scss';
import ButtonPrimary from "../../../../components/button-primary/ButtonPrimary";
import ArrowBg from "../../../../components/arrow-bg/ArrowBg";
import {Link} from "react-router-dom";

const links = [
  { href: '/#features', text: 'Особенности' },
  { href: '/#how-to', text: 'Как это работает' },
  { href: '/#faq', text: 'Вопросы-ответы' },
  { href: '/blog', text: 'Блог' },
  { href: 'https://my.vedmarket.ru/company/login', text: 'Партнерам', isNewTab: true },
  { href: '/#contacts', text: 'Контакты' },
];

type HeaderProps = {
  handleOpen: () => void;
  title: string;
};

function Header({handleOpen, title}: HeaderProps) {

  const [showHeaderScroll, setShowHeaderScroll] = useState(true);

  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const [transitionIsActive, setTransitionIsActive] = useState(true);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollingUp = currentScrollY < lastScrollY.current;

      if (currentScrollY > 90 && scrollingUp) {
        setShowHeaderScroll(true);
      } else if (currentScrollY > 90 && !scrollingUp) {
        setShowHeaderScroll(false);
      } else if (currentScrollY <= 90) {
        setShowHeaderScroll(true);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (menuIsOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [menuIsOpen]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleOpenMenu = () => {
    setMenuIsOpen(true);
  }

  const handleCloseMenu = () => {
    setMenuIsOpen(false);
  }

  const handleClickMobileLink = () => {
    handleCloseMenu();
    setTransitionIsActive(false)

    setTimeout(function() {
      setTransitionIsActive(true)
    }, 1000);
  }

  return (
      <>
        <div className={cx(styles.headerScroll, {
          [styles.headerScrollVisible]: showHeaderScroll,
          [styles.headerScrollHidden]: !showHeaderScroll
        })}>
          <Container className={styles.headerContainer}>
            <Row className="align-items-center justify-content-between">
              <Col xs={4}>
                <a href="https://vedmarket.ru/" className={styles.logoContainer}>
                  <img src={LogoBlack} alt='Вэдмаркет' className={cx(styles.logoScroll, styles.logo)}/>
                </a>
              </Col>
              <Col xl={8} className={styles.menu}>
                <Row className="align-items-center justify-content-between">
                  <Col xs={8} className="pe-0" >
                    <nav className={styles.navbar}>
                      <ul className={styles.navbarList}>
                        <li className={styles.navLink}>
                          <a href="/#features" className={styles.link}>Особенности</a>
                        </li>
                        <li className={styles.navLink}>
                          <a href="/#how-to" className={styles.link}>Как это работает</a>
                        </li>
                        <li className={styles.navLink}>
                          <a href="/#faq" className={styles.link}>Вопросы-ответы</a>
                        </li>
                        <li className={styles.navLink}>
                          <Link to="/blog" className={styles.link}>Блог</Link>
                        </li>
                        <li className={styles.navLink}>
                          <Link to="https://my.vedmarket.ru/company/login" target='_blank' className={styles.link}>Партнерам</Link>
                        </li>
                        <li className={styles.navLink}>
                          <a href="/#contacts" className={styles.link}>Контакты</a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                  <Col xs={3} className="pe-0 ps-0">
                    <div className={styles.buttonContainer}>
                      <ButtonPrimary onClick={handleOpen}/>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={2} className={cx(styles.menuContainer, {
                [styles.menuContainerOpen] : menuIsOpen,
              })}>
                <button type="button" className={styles.menuButton} onClick={menuIsOpen ? handleCloseMenu : handleOpenMenu} aria-label={menuIsOpen ? 'Закрыть меню' : 'Открыть меню'}>
                  {menuIsOpen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                  </svg> : <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.17383 18H21.1738V16H3.17383V18ZM3.17383 13H21.1738V11H3.17383V13ZM3.17383 6V8H21.1738V6H3.17383Z" fill="currentColor"/>
                  </svg>}
                </button>
              </Col>
            </Row>
          </Container>
        </div>
        <div className={cx({
          [styles.headerScrollMenuIsOpen]: menuIsOpen
        })}>
          <div className={cx(styles.menuContainerMobile, {
            [styles.menuContainerMobileTransition] : transitionIsActive,
            [styles.menuContainerMobileActive] : menuIsOpen
          })}>
            <Container className={styles.headerContainer}>
              <Row>
                <Col xs={12}>
                  <nav className={styles.navbarMobile}>
                    <ul className={styles.navbarListMobile}>
                      {links.map(({ href, text, isNewTab }) => (
                          <li key={href} className={styles.navLinkMobile}>
                            <Link to={href} className={styles.linkMobile} onClick={handleClickMobileLink} target={isNewTab ? '_blank' : '_self'}>
                              {text}
                            </Link>
                          </li>
                      ))}
                    </ul>
                  </nav>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <ButtonPrimary onClick={handleOpen} className={styles.buttonMobileOpen}/>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div className={styles.arrowBgMarginTop}>
          <ArrowBg>
            <div className={styles.headerBlog}>
              <Container className={styles.headerContainer}>
                <Row>
                  <Col>
                    <ul className={styles.breadCrumbs}>
                      <li className={styles.breadCrumbsItem}>
                        <a href="/" className={styles.breadCrumbsItemLink}>Главная</a>
                        <img src={ChevronRightIcon} alt=""/>
                      </li>
                      <li className={styles.breadCrumbsItem}>
                        <Link to="/blog" className={styles.breadCrumbsItemLink}>Блог</Link>
                        <img src={ChevronRightIcon} alt=""/>
                      </li>
                      {!isMobile && title && <li className={styles.breadCrumbsItem}>
                        <a href="/" className={styles.breadCrumbsItemTitle}>{title}</a>
                      </li>}
                    </ul>
                  </Col>
                </Row>
                {isMobile && title && <Row>
                  <Col>
                    <span className={cx(styles.breadCrumbsItem, styles.breadCrumbsItemLast)}>
                      <a href="/" className={styles.breadCrumbsItemTitle}>{title}</a>
                    </span>
                  </Col>
                </Row>}
              </Container>
            </div>
          </ArrowBg>
        </div>
      </>
  );
}

export default Header;
